<template>
  <div class="">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="200px"
      class="ruleForm"
    >
      <el-form-item label="项目：" prop="projectName">
        <el-tooltip
          effect="dark"
          :content="ruleForm.projectName"
          placement="top"
        >
          <el-input v-model="ruleForm.projectName" disabled />
        </el-tooltip>
      </el-form-item>
      <el-form-item label="接单企业：" prop="enterpriseName">
        <el-input v-model="ruleForm.enterpriseName" disabled />
      </el-form-item>
      <el-form-item class="input-width" label="税率：" prop="contractScale">
        <el-input
          class="percentage"
          v-model="ruleForm.contractScale"
          :disabled="ifDisable"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="submitForm('ruleForm', 2)"
          :loading="btLoading"
          :disabled="ifDisable"
        >
          保 存
        </el-button>
        <el-button
          type="primary"
          @click="db"
          :loading="btLoading"
          :disabled="ifDisable"
        >
          {{ isConfirm ? '已确认' : '确认' }}
        </el-button>
        <next-project-btn :info="ruleForm" :submitFn="db"></next-project-btn>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { btLoading } from '@/Mixin/btLoading';
/**
 * dbCon
 * setLocalProjectStatus db (methods)
 * isConfirm ifDisable (computed)
 *  */
import { dbCon } from '@/Mixin/doubleConfirm';
import { protocolService } from '@/api/ajax';
import dicSelect from '@/components/Common/dicSelect.vue';
import UploadImgOne from '@/components/Common/UploadImgOne.vue';
import { priceFilter, isInteger, checkTax } from '@/tools/formCheck';
import { moneyComplete, moneyInt } from '@/tools/money';
import nextProjectBtn from '@/components/Judge/NextProjectBtn.vue';
import { mapActions } from 'vuex';

export default {
  mixins: [btLoading, dbCon],
  data() {
    return {
      searchAjax: null,
      prop: {
        label: 'enterpriseName',
        code: 'id'
      },
      initSummary: '',
      initRoleImg: '',
      initProgram: '',
      ruleForm: {
        id: this.$route.query.id,
        enterpriseId: '',
        projectName: '',
        contractScale: null
      },
      yuanPrice: '',
      // 校验
      rules: {
        projectName: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur'
          }
        ],
        enterpriseName: [
          {
            required: true,
            message: '不能为空',
            trigger: 'blur'
          }
        ],
        contractScale: [
          {
            required: true,
            validator: checkTax,
            trigger: 'blur'
          }
        ]
      }
    };
  },
  components: {
    nextProjectBtn,
    dicSelect,
    UploadImgOne
  },
  methods: {
    ...mapActions(['setHomeQuery']),
    resetForm(formName) {
      this.$router.push({
        path: '/assign/index',
        query: {
          id: this.$route.query.id
        }
      });
    },
    submitForm(formName, type) {
      return new Promise((resolve, reject) => {
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.SET_BTLOADING(true);
            this.ruleForm.projectPrefix = 'sass';
            this.ruleForm.type = type;
            protocolService
              .addUpdateAgreementService(this.ruleForm)
              .then(res => {
                this.$notify({
                  title: '成功',
                  message: '操作成功',
                  type: 'success'
                });
                resolve('submit_success');
                this.setLocalProjectStatus(type == 2 ? 0 : type);
              })
              .catch(() => {
                reject('submit_error');
              });
          } else {
            reject('submit_error');
            return false;
          }
        });
      });
    }
  },
  watch: {
    'ruleForm.contractScale'(value) {
      if (/\d+\.\d{3,}$/g.test('' + value)) {
        this.ruleForm.contractScale = Number(value).toFixed(2);
      }
      if (/\s/g.test(`${value}`)) {
        this.ruleForm.contractScale = `${value}`.replace(/\s/g, '');
      }
    }
  },
  created() {
    if (this.$route.query.id) {
      protocolService
        .loadAgreementServiceInfo({
          id: this.$route.query.id
        })
        .then(res => {
          let { enterprise, project, contractScale } = res.data.data;
          project.contractScale = contractScale;
          project.enterpriseName = enterprise.enterpriseName;
          this.ruleForm = project;
          const { fileUpMode, fileUpSource } = project;
          this.setHomeQuery({ fileUpMode, fileUpSource });
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.pic-wrap {
  margin-bottom: -20px;

  li {
    margin-bottom: 20px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }

  .pic-button {
    border: none;
    font-size: 14px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: #5a9cf8;
    line-height: 14px;

    &:hover {
      background-color: transparent;
    }

    &.add-button {
      background-color: transparent;
      padding: 0;
      margin-top: -9px;
    }
  }
}

.sampleBox {
  display: flex;
  align-items: center;

  img {
    width: 200px;
    height: 200px;
  }
}
</style>
